import React from 'react';
import "../DividerSection.css";

function Divider({ fill = "#ffffff", secondaryFill = "#4D6694", tertiaryFill="#f9d423", flipped = false, type = "wavy" }) {

    const getPaths = () => {
        switch (type) {
          case "curved":
            return [
              {
                d: "M0,0 C300,80 600,20 900,80 C1200,140 1440,20 1440,20 L1440,100 L0,100 Z",
                fill: fill
              }
            ];
          case "slant":
            return [
              {
                d: "M0,0 L1440,100 L1440,100 L0,100 Z",
                fill: fill
              }
            ];
          case "two-tone-slant":
            return [
              {
                d: "M0,0 L1440,100 L1440,100 L0,100 Z", // bottom layer
                fill: fill
              },
              {
                d: "M0,100 L1440,0 L1440,100 Z", // top layer
                fill: secondaryFill
              }
            ];
            case "triple-wave":
                return [
                {
                    d: "M0,64 C360,192 1080,-64 1440,96 L1440,100 L0,100 Z",
                    fill: tertiaryFill
                },
                {
                    d: "M0,96 C240,144 960,48 1440,80 L1440,100 L0,100 Z",
                    fill: secondaryFill
                },
                {
                    d: "M0,80 C480,100 960,0 1440,100 L1440,0 L0,0 Z",
                    fill: fill
                }
                ];
                case "mountains":
                    return [
                        {
                          d: "M0,50 C360,30 720,70 1080,50 C1260,40 1440,60 1440,100 L0,100 Z",
                          fill: fill
                        },
                        {
                          d: "M0,70 C360,50 720,90 1080,70 C1260,60 1440,80 1440,100 L1440,100 L0,100 Z",
                          fill: secondaryFill
                        },
                        {
                          d: "M0,90 C360,70 720,110 1080,90 C1260,80 1440,100 1440,100 L1440,100 L0,100 Z",
                          fill: tertiaryFill
                        }
                      ];
          default: // wavy
            return [
              {
                d: "M0,0 C480,100 960,0 1440,100 L1440,0 L0,0 Z",
                fill: fill
              }
            ];
        }
      };
    
      const paths = getPaths();

    return (
      <div className={`section-divider ${flipped ? "flipped" : ""}`}>
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
        {paths.map((path, i) => (
          <path key={i} d={path.d} fill={path.fill} />
        ))}
        </svg>
      </div>
    );
  }
export default Divider